window.addEventListener('load', () => {
  const toggles = document.querySelectorAll('.nav-tree__toggle');

  const mobileToggle = document.querySelector('.nav-tree > button');

  mobileToggle.addEventListener('click', function() {
    const isExpanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', !isExpanded);
  });

  for (let i = 0; i < toggles.length; i++) {
    toggles[i].addEventListener('click', function() {
      const parentclasslist = this.closest('.nav-tree__item').classList;

      if (!parentclasslist.contains('nav-tree__item--active')) {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', !isExpanded);

        parentclasslist.toggle('nav-tree__item--open');
        parentclasslist.toggle('nav-tree__item--closed');
      }
    });
  }
});
